import { combineReducers } from 'redux'
import requestState from './requestState'
import waitState from './waitState'
import employeeProperty from './employeeProperty'

export default combineReducers({
  requestState,
  waitState,
  employeeProperty
})
